// extracted by mini-css-extract-plugin
var _1 = "ParentSupportFallback__body--Jc7d0";
var _2 = "ParentSupportFallback__button--J_Fok CoreGeneral__mainBlueToCyanButton--UIn1H CoreGeneral__colorButton--ZcxJ7 CoreGeneral__colorButtonBase--ROvbs CoreGeneral__roboto--UlmjE CoreGeneral__textSizeW--qtPgT";
var _3 = "ParentSupportFallback__header--eEr8y";
var _4 = "ParentSupportFallback__image--X7Zzx";
var _5 = "ParentSupportFallback__imageContainer--zOFEK";
var _6 = "ParentSupportFallback__mainContainer--WHEgq";
var _7 = "ParentSupportFallback__textAndButtonContainer--eUUlL";
export { _1 as "body", _2 as "button", _3 as "header", _4 as "image", _5 as "imageContainer", _6 as "mainContainer", _7 as "textAndButtonContainer" }
